import { render, staticRenderFns } from "./TimelineExpedient.vue?vue&type=template&id=5e6601cf"
import script from "./TimelineExpedient.vue?vue&type=script&lang=js"
export * from "./TimelineExpedient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports